<template>
  <div class="BaseLayerSet">
    <div class="baseInfo">
      <div class="title">
        <span class="line"></span>
        <span>基本信息</span>
      </div>
      <el-form :model="layerInfo" :rules="rules" ref="ruleForm" label-width="0" class="demo-ruleForm">
        <div class="label" style="color: rgba(255, 255, 255, 0.3);;font-size: 13px">{{layerInfo.type!=='FOLDER'?'图层名称':'文件夹名称'}}</div>
        <el-form-item prop="name">
          <el-input v-model.trim="layerInfo.name" placeholder="请输入内容" @change="onValueChange" @input="onValueChange" :maxlength="20" show-word-limit></el-input>
        </el-form-item>
        <div class="label" style="color: rgba(255, 255, 255, 0.3);font-size: 13px">所属文件夹</div>
        <el-form-item>
          <!-- <el-select v-model="value" placeholder="请选择" disabled  @change="onValueChange">
            <el-option
              v-for="item in options"
              :key="item.value"
              :label="item.label"
              :value="item.value">
            </el-option>
          </el-select> -->
          <TreeSelect class="form-short" v-model="layerInfo.parentId" filterable clearable :options="filtedFolderTree" :props="folderProps" placeholder="请选择" @change="onValueChange"></TreeSelect>
        </el-form-item>
      </el-form>
      <div class="type" v-show="layerInfo.type!=='FOLDER'">
        <span class="label">关联数据源</span>
        <!-- <el-button type="default" @click="showBindData" v-show="layerInfo.tableId && layerInfo.type === 'POINT' && isHaveGis(layerInfo.properties)">
          <svg width="1em" height="1em" fill="currentColor" aria-hidden="true">
            <use xlink:href="#icon-update"></use>
          </svg>
        </el-button> -->
        <!-- <el-button type="default" @click="showBindData" v-show="layerInfo.tableId">
          <svg width="1em" height="1em" fill="currentColor" aria-hidden="true">
            <use xlink:href="#icon-unlink"></use>
          </svg>
        </el-button> -->
        <el-tooltip :content="'解除关联'" placement="top" effect="light" :open-delay="50">
          <Icon type="" name="icon-unlink" @click="unBindData" v-show="layerInfo.tableId && !layerInfo.dataFree"></Icon>
        </el-tooltip>
        <el-tooltip :content="'数据更新'" placement="top" effect="light" :open-delay="50">
          <Icon type="" name="icon-update" @click="showBindData" v-show="(layerInfo.tableId && !layerInfo.dataFree)||layerInfo.dataSourceType==='API'"></Icon>
        </el-tooltip>
        <div class="link-data">
          <div class="title" v-if="(layerInfo.tableId && !layerInfo.dataFree)||layerInfo.dataSourceType==='API'">
            <svg width="1em" height="1em" fill="currentColor" aria-hidden="true">
              <use xlink:href="#icon-link"></use>
            </svg>
            {{dataSourceName}}
          </div>
          <div class="title" v-else-if="layerInfo.module==='sppuc' && layerInfo.extendConfig.isSppucData===true">
            <svg width="1em" height="1em" fill="currentColor" aria-hidden="true">
              <use xlink:href="#icon-link"></use>
            </svg>
            融合通信-{{SPPUCDeviceTypeList.find(item=>{return item.value===layerInfo.extendConfig.deviceType}).label}}
          </div>
          <div class="title empty" v-else style="width: 100%">
            该图层未关联数据源
          </div>
        </div>
        <div v-if="layerInfo.type!=='FOLDER' && (!layerInfo.pointStyle || layerInfo.pointStyle.type !== 'HEAT_MAP')">
        <div class="styleSetting">
          <div class="title">
            <span class="line"></span>
            <span>分享交互设置</span>
          </div>
          <div>
            <div class="form-item">
              <div class="label">飞向标注</div>
              <el-switch
                v-model="layerInfo.action.flyTo"
                active-color="#00A4F0"
                inactive-color="#494B4D"
                @change="onValueChange">
              </el-switch>
            </div>
            <div class="form-item" v-if="layerInfo.module!=='sppuc'">
              <div class="label">信息弹窗</div>
              <el-select v-model="layerInfo.action.uiType" placeholder="请选择" @change="onValueChange" :popper-append-to-body="false">
                <el-option
                  v-for="item in actionUIType"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id">
                </el-option>
              </el-select>
            </div>
          </div>
        </div>
      </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getDetails } from '@/api/dataManagement'
import { isHaveGis, cloneObject } from '@/utils/util'
import TreeSelect from '@/components/TreeSelect/TreeSelect'
import { mapGetters } from 'vuex'
import { treeForeach, searchBFS } from '@/utils/tree'
import { freeLayer } from '@/api/marker'
import * as dataManagement from '@/api/dataManagement'
import { actionUIType } from '@/utils/markerStyles'
import { SPPUCDeviceTypeList } from './sppuc/SppucManager'
export default {
  name: 'BaseLayerSet',
  props: {},
  components: {
    TreeSelect
  },
  inject: ['saveLayerCheck', 'markerViewer'],
  computed: {
    ...mapGetters(['folderTree']),
    filtedFolderTree () {
      const data = JSON.parse(JSON.stringify(this.folderTree))
      if (this.layerInfo.type === 'FOLDER') {
        treeForeach(data, 'children', (item) => {
          const folderId = item.id
          if (this.layerInfo.children) {
            const res = searchBFS(this.layerInfo.children, 'children', (childItem) => {
              return childItem.id === folderId
            })
            if (res && res.length > 0) {
              item.disabled = true
            }
          }
          if (this.layerInfo.id === item.id) {
            item.disabled = true
          }
        })
      }
      // debugger
      return data
    }
  },
  data () {
    return {
      SPPUCDeviceTypeList,
      // 样式属性
      layerInfo: {
        name: undefined,
        tableId: undefined,
        type: undefined,
        parentId: 0,
        action: {
          flyTo: true,
          uiType: 'default'
        }
      },
      rules: {
        name: [
          { required: true, message: '请输入图层名称', trigger: 'blur' },
          { min: 1, max: 20, message: '请输入1~20个字符', trigger: 'blur' }
        ]
      },
      // 保存的原始信息
      originInfo: undefined,
      dataSourceName: undefined,

      folderProps: {
        value: 'id',
        label: 'name',
        children: 'children',
        disabled: 'disabled'
      },
      value: '选项1',
      input: '点图层3',
      actionUIType
    }
  },
  // watch: {
  //   layerInfo: {
  //     deep: true,
  //     handler: function (val, oldVal) {
  //       if (val && oldVal && val.id === oldVal.id) {
  //         this.$emit('layerStyleChanged', true)
  //       }
  //     }
  //   }
  // },
  methods: {
    setData (data) {
      this.layerInfo = data
      if (!this.layerInfo.action || !this.layerInfo.action.uiType) { // 兼容老数据
        this.$set(this.layerInfo, 'action', {
          flyTo: true,
          uiType: 'default'
        })
      }
      this.setOrigin(data)
      if (this.layerInfo.dataSourceType === 'API') {
        this.getApiData()
      } else if (this.layerInfo.tableId) {
        this.getTablesData()
      }
    },
    async getApiData () {
      const res = await dataManagement.getApiDetails({
        id: this.layerInfo.dataSourceId
      })
      this.dataSourceName = res.data.name
    },
    // 获取表格数据
    getTablesData (id) {
      getDetails({
        id: this.layerInfo.tableId
      }).then(res => {
        if (res.code === 200) {
          this.dataSourceName = res.data.name
        }
      })
    },
    // 绑定数据
    showBindData (v) {
      if (this.markerViewer.layerChanged) {
        this.saveLayerCheck()
        return
      }
      this.$emit('bindTable', {
        layerId: this.layerInfo.id,
        tableId: this.layerInfo.tableId,
        dataSourceType: this.layerInfo.dataSourceType,
        dataSourceId: this.layerInfo.dataSourceId
      })
    },
    // 解除数据绑定
    async unBindData () {
      if (this.markerViewer.layerChanged) {
        this.saveLayerCheck()
        return
      }
      this.$Delete({
        message: '解除关联后对应的标注点将清空，是否确认解除关联？',
        confirm: async () => {
          const res = await freeLayer({
            layerId: this.layerInfo.id
          })
          if (res.code === 200) {
            this.layerInfo.dataFree = true
            this.$Message('success', res.msg || '操作成功！')
            this.$cesiumPlus.markerManager.removeMarkerByLayer(this.layerInfo.id)
            this.$emit('refresh')
          }
        }
      })
    },
    // 还原数据
    resetData () {
      cloneObject(this.originInfo, this.layerInfo)
    },
    // 设置原始数据
    setOrigin (data) {
      this.originInfo = JSON.parse(JSON.stringify(data))
    },
    isHaveGis (data) {
      return isHaveGis(data)
    },
    // 属性值修改
    onValueChange () {
      if (this.layerInfo.name) {
        this.$emit('layerStyleChanged', this.layerInfo)
      }
    },
    // 清除数据
    clear () {
      this.layerInfo = {
        name: undefined,
        tableId: undefined,
        type: undefined
      }
      this.dataSourceName = undefined
    }
  },
  filters: {}
}
</script>

<style lang="scss">
  .BaseLayerSet{
    text-align: left;
    .title{
      color: #FFFFFF;
      font-size: 14px;
      margin-bottom: 15px;
      >.line{
        display: inline-block;
        margin-right: 4px;
        width: 3px;
        height: 10px;
        background: #00A4F0;
        border-radius: 2px;
      }
    }
    .el-input .el-input__inner{
      font-size: 12px !important;
    }
    .el-input__prefix{
      display: flex;
      align-items: center;
      padding-left: 10px;
      >img{
        width: 15px;
        height: 15px;
      }
    }
    .baseInfo{
      border-bottom: 1px solid #424345;
      padding: 16px 12px;
      box-sizing: border-box;
      padding-bottom: 0 !important;
      .form-item{
        margin-bottom: 16px;
        >.label{
          font-size: 12px;
          font-weight: 300;
          color: #999999;
          // margin-bottom: 8px;
        }
      }
      .type{
        margin-bottom: 5px;
        .label{
          font-size: 13px;
          color: rgba(255, 255, 255, 0.3);
        }
        .el-button{
          height: 0.24rem;
          padding: 0px 4px !important;
          svg{
            font-size: 12px;
          }
        }
        .custom-icon{
          width: 24px;
          padding: 3px;
          font-size: 12px;
          color: #bbb;
          float: right;
        }
        .value{
          font-size: 13px;
          color: #00A4F0;
        }
        .link-data{
          display: flex;
          align-items: flex-start;
          margin-top: 10px;
          .title{
            font-size: 12px;
            color: #00A4F0;
            min-height: 32px;
            border: 1px dashed rgba(255, 255, 255, 0.15);
            border-radius: 4px;
            padding: 5px;
            width: 100%;
            display: inline-block;
            &.empty{
              width: 235px;
              color: #666666;
              text-align: center;
              svg{
                display: none;
              }
            }
          }
          .el-button{
            // width: 32px;
            // height: 32px;
            padding: 0 8px !important;
            margin-left: 10px;
          }
        }
      }
    }
    .styleSetting{
      // border-bottom: 1px solid #424345;
      padding: 16px 0px;
      box-sizing: border-box;
      .imgType{
        list-style: none;
        display: flex;
        flex-wrap: wrap;
        justify-content: flex-start;
        padding: 0 0;
        >li{
          width: 60px;
          height: 90px;
          border-radius: 6px;
          position: relative;
          margin-right: 12px;
          .el-image{
            width: 60px;
            height: 60px;
            border-radius: 6px;
            cursor: pointer;
            border: 2px solid rgba(0, 164, 240, 0);
            box-sizing: border-box;
            &.active{
              border: 2px solid rgba(0, 164, 240, 0.94);
              box-shadow: 0 0 7px rgba(25, 195, 240, 0.9);
            }
          }
          img{
            width: 100%;
            height: 100%;
          }
          .name{
            font-size: 12px;
            font-family: Source Han Sans SC;
            font-weight: 400;
            color: #999999;
            text-align: center;
            transform: translateY(-2px);
          }
          .check{
            position: absolute;
            right: 0;
            top: 40px;
          }
        }
      }
      .form-item{
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin-bottom: 8px;
        .label{
          width: 120px;
          font-size: 12px;
          color: #999999;
        }
        .slider{
          width: 230px;
          height: 32px;
          background: #424243;
          border-radius: 6px;
          overflow: hidden;
          display: flex;
          align-items: center;
          padding: 0 12px;
          box-sizing: border-box;
          .el-slider{
            width: 100%;
            .el-slider__runway{
              height: 4px;
            }
            .el-slider__bar{
              height: 4px;
              background-color: $primary-color;
            }
            .el-slider__button{
              width: 8px;
              height: 8px;
              border: solid 0.02rem #ffffff;
              background-color: $primary-color;
              transform: translateY(-1px);
            }
          }
        }
      }
    }
  }
</style>
